module.exports = __webpack_public_path__ + "0daff5bf1376fa8759b9770151d03f46.svg";